import { Component, OnInit, OnDestroy } from '@angular/core';


@Component({
    selector: 'app-equipment-empty',
    templateUrl: './equipment-empty.component.html',
    styleUrls: ['./equipment-empty.component.scss'],
    standalone: false
})
export class EquipmentEmptyComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }
}
